import { getApp, getApps, initializeApp } from 'firebase/app';
import {
  fetchAndActivate,
  getBoolean,
  getNumber,
  getRemoteConfig,
  getString,
  getValue,
} from 'firebase/remote-config';
import { getFirebaseConfig } from './firebase-remote-config.context';
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREABSE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
};

export interface firebaseConfig {
  apiKey?: string;
  authDomain?: string;
  databaseURL?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
}

export interface IFirebaseConfig {
  is_mqtt_enabled_poll_web?: boolean;
  is_service_down_web?: boolean;
  pw_skill_url?: string;
  otp_timer_prod?: number;
  otp_timer_staging?: number;
  whatsapp_otp_disabled_web?: string;
  whatsapp_otp_disabled_web_staging?: string;
  voice_call_enabled_web?: string;
  voice_call_enabled_web_staging?: string;
  auth_help_visibile_count?: number;
  auth_help_visibile_count_stage?: number;
  auth_revamp_stage_web?: boolean;
  otp_less_config?: string;
  enable_v2_auth_flow?: boolean;
  pw_cloudflare_captcha_enabled_web_staging: boolean;
  pw_cloudflare_captcha_enabled_web_prod: boolean;
  chat_feature_config: string;
  goodies_banner_config: string;
  space_web_redirect_config: string;
  rating_after_streak?: string;
  streak_calendar_config: string;
}

export type DefaultFirebaseConfig = Record<keyof IFirebaseConfig, string | number | boolean>;

export const defaultConfig: DefaultFirebaseConfig = {
  is_mqtt_enabled_poll_web: false,
  is_service_down_web: false,
  pw_skill_url: '',
  otp_timer_prod: 30,
  otp_timer_staging: 30,
  whatsapp_otp_disabled_web: '[]',
  whatsapp_otp_disabled_web_staging: '[]',
  voice_call_enabled_web_staging: '[]',
  voice_call_enabled_web: '[]',
  auth_help_visibile_count: 0,
  auth_help_visibile_count_stage: 0,
  auth_revamp_stage_web: false,
  otp_less_config: '{"configs": []}',
  enable_v2_auth_flow: false,
  pw_cloudflare_captcha_enabled_web_staging: false,
  pw_cloudflare_captcha_enabled_web_prod: false,
  chat_feature_config: '{"configs": []}',
  goodies_banner_config: '{}',
  space_web_redirect_config: '{}',
  rating_after_streak: '{}',
  streak_calendar_config: '[]',
};
// Function to fetch and activate remote config

// Initialize Firebase

let remoteConfig: any;
export const fetchAndActivateConfig = async (appFirebaseConfig?: firebaseConfig) => {
  try {
    // Fetch and activate remote config
    const firebaseApp = getApps().length
      ? getApp()
      : initializeApp(getFirebaseConfig(appFirebaseConfig, firebaseConfig));
    remoteConfig = getRemoteConfig(firebaseApp);
    remoteConfig.defaultConfig = defaultConfig;
    await fetchAndActivate(remoteConfig);
  } catch (err) {
    console.error('Error fetching and activating remote config: ', err);
  }
};

/**
 * TypeScript Magic ✨
 * */
function createDynamicGetters(obj: DefaultFirebaseConfig) {
  const result: Partial<DefaultFirebaseConfig> = {};

  // If remoteConfig is not available, return default values
  if (!remoteConfig) {
    console.warn('Firebase Remote Config not initialized. Using default values.');
    return obj;
  }

  // console.log(typeof defaultConfig.is_mqtt_enabled_poll_web);
  for (const key in obj) {
    try {
      // @ts-ignore
      if (typeof defaultConfig[key] === 'boolean') {
        // @ts-ignore
        result[key] = getBoolean(remoteConfig, key);

        // @ts-ignore
      } else if (typeof defaultConfig[key] === 'string') {
        // @ts-ignore
        result[key] = getString(remoteConfig, key);

        // @ts-ignore
      } else if (typeof defaultConfig[key] === 'number') {
        // @ts-ignore
        result[key] = getNumber(remoteConfig, key);
      } else {
        // @ts-ignore
        result[key] = getValue(remoteConfig, key)?.value;
      }
    } catch (err) {
      // Fallback to default value if remote config fails
      // @ts-ignore
      result[key] = defaultConfig[key];
    }
  }

  return result;
}

export const firebaseConfigDynamicGetters = () => createDynamicGetters(defaultConfig);
